// config.js

console.log('API URL:', process.env.REACT_APP_API_URL);
const mainDefaultIP = process.env.REACT_APP_API_URL || `${window.location.origin}/`;

console.log('Main Default IP:', mainDefaultIP);

export default mainDefaultIP; 